import { useState } from 'react';
import FieldRenderer from '../FieldRenderer/FieldRenderer';
import './ClientInfoSection.css';

const CATEGORY_ORDER = [
  'Personal Details',
  'Contact Information',
  'KYC Documents',
  'Financial Details',
  'Professional Details',
  'Family Details',
  'Referral'
];

export default function ClientInfoSection({ fields, profileData, onSave, onMarkNa, onRemoveNa, onAddNote, onFlag, onRemoveFlag, saving }) {
  const responses = profileData?.responses || {};
  const hiddenFieldUids = profileData?.hidden_field_uids || [];
  const fieldNotes = profileData?.field_notes || {};
  const flaggedFieldUids = profileData?.flagged_field_uids || [];

  const [localResponses, setLocalResponses] = useState({ ...responses });
  const [activeCategory, setActiveCategory] = useState(null);

  // Group fields by category
  const fieldsByCategory = {};
  for (let i = 0; i < fields.length; i++) {
    const field = fields[i];
    const cat = field.category || 'General';
    if (!fieldsByCategory[cat]) {
      fieldsByCategory[cat] = [];
    }
    fieldsByCategory[cat].push(field);
  }

  // Get ordered categories
  const allCategories = Object.keys(fieldsByCategory);
  const orderedCategories = [];
  for (let i = 0; i < CATEGORY_ORDER.length; i++) {
    if (fieldsByCategory[CATEGORY_ORDER[i]]) {
      orderedCategories.push(CATEGORY_ORDER[i]);
    }
  }
  for (let i = 0; i < allCategories.length; i++) {
    if (!orderedCategories.includes(allCategories[i])) {
      orderedCategories.push(allCategories[i]);
    }
  }

  // Set initial active category
  const currentActive = activeCategory || (orderedCategories[0] || null);

  function isCategoryComplete(category) {
    const catFields = fieldsByCategory[category] || [];
    for (let i = 0; i < catFields.length; i++) {
      const field = catFields[i];
      if (!field.required) continue;
      if (hiddenFieldUids.includes(field.uid)) continue;
      const val = localResponses[field.uid];
      if (!val || val.toString().trim() === '' || val.toString() === '[]') {
        return false;
      }
    }
    return catFields.some(f => f.required);
  }

  function handleFieldChange(uid, value) {
    setLocalResponses(prev => ({ ...prev, [uid]: value }));
  }

  function handleSave() {
    onSave(localResponses);
  }

  const activeFields = fieldsByCategory[currentActive] || [];

  return (
    <div className="ci-section">
      <div className="ci-section__category-tabs">
        {orderedCategories.map(cat => (
          <button
            key={cat}
            className={`ci-section__cat-tab ${currentActive === cat ? 'ci-section__cat-tab--active' : ''}`}
            onClick={() => setActiveCategory(cat)}
          >
            {isCategoryComplete(cat) && <span className="ci-section__cat-dot ci-section__cat-dot--done" />}
            {!isCategoryComplete(cat) && <span className="ci-section__cat-dot" />}
            {cat}
          </button>
        ))}
      </div>

      <div className="ci-section__fields">
        {activeFields.map(field => (
          <FieldRenderer
            key={field.uid}
            field={field}
            value={localResponses[field.uid]}
            onChange={handleFieldChange}
            isNa={hiddenFieldUids.includes(field.uid)}
            hasNote={fieldNotes[field.uid] || false}
            isFlagged={flaggedFieldUids.includes(field.uid)}
            onMarkNa={onMarkNa}
            onRemoveNa={onRemoveNa}
            onAddNote={onAddNote}
            onFlag={onFlag}
            onRemoveFlag={onRemoveFlag}
          />
        ))}
        {activeFields.length === 0 && (
          <p className="ci-section__empty">No fields in this category.</p>
        )}
      </div>

      <div className="ci-section__footer">
        <button className="btn--primary" onClick={handleSave} disabled={saving}>
          {saving ? 'Saving...' : 'Save Client Info'}
        </button>
      </div>
    </div>
  );
}
